import React from 'react';
import styles from './LoadingSpinner.scss';
export var LoadingSpinner = function LoadingSpinner(props) {
  var message = props.message,
      variant = props.variant,
      className = props.className;
  var variantStyles = styles[variant];
  return React.createElement("div", {
    className: "".concat(styles.container, " ").concat(variantStyles, " ").concat(className),
    "data-test": props.dataTest
  }, React.createElement("div", {
    className: styles.spinnerPositioner
  }, React.createElement("div", {
    className: styles.spinnerBase
  }), React.createElement("div", {
    className: styles.spinner
  })), React.createElement("div", {
    "data-test": "".concat(props.dataTest, "-message"),
    className: styles.message
  }, message));
};
LoadingSpinner.defaultProps = {
  className: '',
  dataTest: 'loading-indicator',
  message: '',
  variant: 'inline'
};